<template>
  <div class="search_content">
    <div class="hot_search">
      <p class="title" v-if="$store.state.hotLisat.length > 0">热门搜索</p>
      <ul>
        <li v-for="(item,index) in $store.state.hotLisat" :key="index" @click="
        $router.push({
          path: '/gameDetails',
          query: {
            id: item.gameId,
          },
        })
      ">{{item.searchName}}</li>
        <!-- <li style="visibility: hidden"></li>
        <li style="visibility: hidden"></li> -->
      </ul>
    </div>
    <div class="search_result">
      <p class="title" >搜索结果</p>
      <ul v-if="$store.state.searList.length > 0">
        <li v-for="(item, index) in $store.state.searList" :key="index" @click="
        $router.push({
          path: '/gameDetails',
          query: {
            id: item.resultID,
          },
        })
      ">
          {{ item.searchResult }}
        </li>
      </ul>
      <p v-else>暂无搜索结果</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    console.log(this.$store.state.searList);
  },
};
</script>

<style lang="less"  scoped>
.search_content {
  background: #f8f8f8;
  .hot_search {
    margin-left: 5vw;
    margin-top: 2vw;
    .title {
      text-align: left;
      font-size: 3.5vw;
      color: #333333;
    }
    ul {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      margin-right: 3vw;
      margin-top: 2vw;
      li {
        height: 9vw;
        line-height: 9vw;
        flex: 20%;
        color: #000;
        font-size: 3vw;
        background: #ffcd86;
        padding: 0.5vw 1vw;
        border-radius: 3vw;
        margin-bottom: 4vw;
        margin-right: 2vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .search_result {
    margin-left: 5vw;
    margin-top: 3vw;
    padding-bottom: 15vw;
    p{
      font-size: 3vw;
    }
    .title {
      text-align: left;
      font-size: 3.5vw;
      color: #333333;
      margin-bottom: 2vw;
    }
    ul {
      li {
        text-align: left;
        font-size: 4vw;
        margin-bottom: 3vw;
      }
    }
  }
}
</style>